exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-community-js": () => import("./../../../src/pages/community.js" /* webpackChunkName: "component---src-pages-community-js" */),
  "component---src-pages-crowdfunding-js": () => import("./../../../src/pages/crowdfunding.js" /* webpackChunkName: "component---src-pages-crowdfunding-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-pledge-js": () => import("./../../../src/pages/pledge.js" /* webpackChunkName: "component---src-pages-pledge-js" */)
}

